module.exports = __webpack_public_path__ + "img/1-11.d5e50e7f.png";